module.exports = __webpack_public_path__ + "static/backgroundImage@2x-a4614d6b11e5fced3129fbfa0cbfdd9c.png";